import { render, staticRenderFns } from "./distributed.vue?vue&type=template&id=e88a86cc&scoped=true&"
import script from "./distributed.vue?vue&type=script&lang=js&"
export * from "./distributed.vue?vue&type=script&lang=js&"
import style0 from "./distributed.vue?vue&type=style&index=0&id=e88a86cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88a86cc",
  null
  
)

export default component.exports